module.exports = __webpack_public_path__ + "static/media/JBL_Partybox.67dddb2c.reality";